import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { parse } from 'date-fns';

import { withFormik } from 'formik';
import * as yup from 'yup';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

import { FormControl, FormControlLabel, FormGroup, Checkbox, Typography } from '@material-ui/core';
import estrela from '../../../../assets/images/stargold.png';
import Tooltip from '@material-ui/core/Tooltip';


import Input from '../../../../components/Input/Input';

const styles = theme => ({
  button: {
    display: 'inherit',
    margin: `${theme.spacing(2)}px auto`,
    minWidth: '300px',
    minHeight: '50px',
  },
  hover: {
    borderRadius: '1em',
    padding: '33px 15px',
    textAlign: 'center',
    width: '100%',
    color: '#537ccd',
    textTransform: 'none',
    marginRight: '2px',
    fontWeight: 400,
    '&:hover': {
      color: '#6880c3',
      backgroundColor: '#f2b002',
    }
  }
});


const Form = (props) => {
  const {
    handleNewHasBlockedDevice,
    hasBlockedDevice,
    hasRestrictDevice,
    locations,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    returning,
  } = props;

  const [check, setCheck] = useState(false);
  const [state, setState] = useState()

  const handleChecked = (e) => {
    setCheck(e.target.checked);
    if (e.target.checked == false) {
      handleNewHasBlockedDevice("NO_RESTRICTION")
    }
  }

  useEffect(() => {
    setCheck(hasBlockedDevice ? hasBlockedDevice.hasRestrictDevice : false);
    setState(hasBlockedDevice ? hasBlockedDevice.hasBlockedDevice : 'NO_RESTRICTION')
  }, [hasBlockedDevice ? hasBlockedDevice.hasRestrictDevice : false])

  // console.log('device', hasBlockedDevice)
  const { values, classes } = props;

  const DeviceBlocked = {
    hasRestrictDevice: false,
    hasBlockedDevice: 'NO_RESTRICTION',
    listBlockedDevice: [{ value: "NO_RESTRICTION", name: "SEM RESTRIÇÃO" },
    { value: "MOBILE_ONLY", name: "APENAS APLICATIVO" },
    { value: "WEB_ONLY", name: "APENAS PONTO-WEB" }]
  }

  const formFields = [
    {
      elementType: 'datePicker',
      config: {
        name: 'dtRef',
        label: 'Início das restrições',
        required: true,
        isFormik: true,
      },
      helperText: ' ',
    },
  ];

  let formFieldsAux = [
    ...formFields,
  ];


  if (props.values.restrictByLocation && check) {
    formFieldsAux.push(
      {
        elementType: 'select',
        config: {
          name: 'locations',
          SelectProps: { multiple: true },
          label: 'Locais',
          required: true,
          options: locations.map(location => ({
            value: location.id,
            displayValue: location.description,
          })),
        },
        helperText: ' ',
      },
      {
        elementType: 'select',
        config: {
          name: 'hasBlockedDevice',
          SelectProps: { value: state },
          label: 'Aparelhos',
          required: true,
          options: hasBlockedDevice ? hasBlockedDevice.listBlockedDevice == null || undefined ?
            DeviceBlocked.listBlockedDevice.map(i => ({
              value: i.value == "NO_RESTRICTION" ? '' : i.value,
              displayValue: i.name == "SEM RESTRIÇÃO" ? '' : i.name,
            }))
            :
            hasBlockedDevice?.listBlockedDevice?.map(i => ({
              value: i.value == "NO_RESTRICTION" ? '' : i.value,
              displayValue: i.name == "SEM RESTRIÇÃO" ? '' : i.name,
            }))
            :
            DeviceBlocked.listBlockedDevice.map(i => ({
              value: i.value == "NO_RESTRICTION" ? '' : i.value,
              displayValue: i.name == "SEM RESTRIÇÃO" ? '' : i.name,
            })),
        },
        helperText: ' ',
      }
    );

  } else if (props.values.restrictByLocation) {
    formFieldsAux.push({
      elementType: 'select',
      config: {
        name: 'locations',
        SelectProps: { multiple: true },
        label: 'Locais',
        required: true,
        options: locations.map(location => ({
          value: location.id,
          displayValue: location.description,
        })),
      },
      helperText: ' ',
    });
  } else if (check) {
    formFieldsAux.push({
      elementType: 'select',
      config: {
        name: 'Aparelhos',
        SelectProps: { value: state },
        label: 'Aparelhos',
        required: true,
        options: hasBlockedDevice ? hasBlockedDevice.listBlockedDevice == null || undefined ?
          DeviceBlocked.listBlockedDevice.map(i => ({
            value: i.value == "NO_RESTRICTION" ? '' : i.value,
            displayValue: i.name == "SEM RESTRIÇÃO" ? '' : i.name,
          }))
          :
          hasBlockedDevice?.listBlockedDevice?.map(i => ({
            value: i.value == "NO_RESTRICTION" ? '' : i.value,
            displayValue: i.name == "SEM RESTRIÇÃO" ? '' : i.name,
          }))
          : DeviceBlocked.listBlockedDevice.map(i => ({
            value: i.value == "NO_RESTRICTION" ? '' : i.value,
            displayValue: i.name == "SEM RESTRIÇÃO" ? '' : i.name,
          })),
      },
      helperText: ' ',
    });
  } else {
    formFieldsAux = [
      ...formFields,
    ];
  }
  // console.log(hasRestrictDevice)

  if (returning) {
    props.setReturning(false);
    props.formValues(values);
  }
  if (props.formValues) {
    props.formValues(values);
  }
  if (props.submit) {
    if (props.submit.toggle) {
      props.setSubmit({ event: null, toggle: false });
      props.handleSubmit(props.submit.event);
    }
  }

  if (Object.entries(props.errors).length === 0 && props.errors.constructor === Object) {
    props.setRestrictionsIsValid && props.setRestrictionsIsValid(true);
  } else {
    props.setRestrictionsIsValid && props.setRestrictionsIsValid(false);
  }

  const restrictionApp = []
  const [premium] = useState(JSON.parse(localStorage.getItem('privileges')).isExportAfd)
  const [premiumItem, setPremiumItem] = useState(false)

  function handleChangeHover(status) {
    if (!premium) {
      setPremiumItem(status)
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}

    >
      <Grid item container spacing={2}>
        {formFieldsAux.map((field, index) => {
          const items = [];
          if (index === 0) {
            items.push((
              <Grid item xs={12} sm={4} key="fieldset" style={{ display: 'flex' }}>
                <FormControl component="fieldset" style={{ margin: 'auto', marginLeft: '0' }}>
                  {!premiumItem ?
                    <FormGroup row
                      onMouseEnter={() => handleChangeHover(true)}
                      onMouseLeave={() => handleChangeHover(false)}>
                      <FormControlLabel
                        key="hasPhoto"
                        name="hasPhoto"
                        control={<Checkbox
                          color="primary"
                          checked={values.hasPhoto}
                          onChange={handleChange}
                          value={values.hasPhoto} />}
                        label={"Necessário Foto"}
                      />

                      <FormControlLabel
                        key="restrictByLocation"
                        name="restrictByLocation"
                        control={<Checkbox
                          color="primary"
                          checked={values.restrictByLocation}
                          onChange={handleChange}
                          value={values.restrictByLocation} />}
                        label={"Restringir Local"}
                      />

                      <FormControlLabel
                        key="hasRestrictDevice"
                        name="hasRestrictDevice"
                        control={<Checkbox
                          color="primary"
                          checked={check}
                          onChange={handleChecked}
                          value={check} />}
                        label={"Restringir Dispositivo"}
                      />
                    </FormGroup>
                    :
                    <div
                      onMouseEnter={() => handleChangeHover(true)}
                      onMouseLeave={() => handleChangeHover(false)}
                    >
                      <Button
                        className={classes.hover}
                        component={Link}
                        to='/assinatura'
                      >
                        <Typography style={{ fontSize: '13px' }}>
                          Seja Premium para restringir permissões para o seu funcionário
                        </Typography>
                      </Button>
                    </div>
                  }
                </FormControl>
              </Grid>
            ));
          }

          items.push((
            <Grid item xs={12} sm={6} key={field.config.name}>
              <Input
                {...field.config}
                elementType={field.elementType}
                value={values[field.config.name]}
                onChange={field.elementType === 'datePicker' ? setFieldValue : handleChange}
                onClick={(value) => {
                  handleNewHasBlockedDevice(value.target.value)
                  setState(value.target.value)
                }
                }
                onBlur={handleBlur}
                fullWidth
                margin="normal"
                error={errors[field.config.name] && touched[field.config.name]}
                helperText={
                  (touched[field.config.name] && errors[field.config.name]) || field.helperText
                }
              />
            </Grid>
          ));
          return items;
        })}
      </Grid>

      {
        props.innerSubmit ? (
          <Grid item container justify="flex-end" spacing={1} >
            <Button
              onClick={props.close}
              style={{ marginRight: 10, marginTop: 10, marginBottom: 20 }}
              onChange={() => handleNewHasBlockedDevice('')}
            >
              FECHAR
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={props.handleSubmit}
              onChange={() => handleNewHasBlockedDevice('')}
              style={{ marginTop: 10, marginBottom: 20 }}
            >
              SALVAR
            </Button>
          </Grid>
        ) : null
      }
    </form >
  );
};

const initializeDateForm = item => (item ? parse(item, 'yyyy-MM-dd', new Date()) : null);
const initializeBoolean = item => item || false;


const Restrictions = withFormik({
  enableReinitialize: false,
  mapPropsToValues: props => ({
    dtRef: initializeDateForm(props.data.dtRef),
    restrictByLocation: initializeBoolean(props.data.restrictByLocation),
    // hasRestrictDevice: initializeBoolean(props.hasBlockedDevice.hasRestrictDevice),
    hasPhoto: initializeBoolean(props.data.hasPhoto),
    locations: props.data.locations || [],
    hasBlockedDevice: props.hasBlockedDevice || {},
    handleNewHasBlockedDevice: props.handleNewHasBlockedDevice,
  }),
  validationSchema: props => yup.lazy((values) => {
    const rules = {};
    if (values.restrictByLocation) {
      rules.dtRef = yup.string().nullable().required('Este campo é obrigatorio');
      rules.locations = yup.array().of(yup.number().required('Local invalido')).min(1, 'Este campo é obrigatório');
    }

    if (values.hasPhoto) {
      rules.dtRef = yup.string().nullable().required('Este campo é obrigatorio');
    }

    return yup.object().shape(rules);
  }),
  handleSubmit: (values, { props }) => {
    if (props.innerSubmit) {
      props.updateEmployee(values);
      props.close();
    } else {
      props.formValues(values);
      props.setFormsStatus({ ...props.formsStatus, restrictions: true });
    }
  },
})(Form);

export default withStyles(styles)(withRouter(Restrictions));
